module.exports = "//public.zight.com/packs/media/images/cloudapp-favicon-d053fc47958e1b85c892b5de0d7ac93a.png";